module.exports = __webpack_public_path__ + "img/loginBg.2e0655a5.jpg";